import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.scss']
})
export class NavMenuComponent implements OnInit {
  @Input()
  activeMenu: string

  @Input()
  menuList = []

  @Output()
  selectedMenu = new EventEmitter()

  _onSelectMenu(key) {
    this.activeMenu = key
    this.selectedMenu.emit(key)
  }

  mapToDropdown() {
    return this.menuList.map(item => ({ id: item.key, value: item.title }))
  }

  constructor() { }

  ngOnInit() {
  }

}
